<template>
    <!-- TODO css -->
    <modal @close="close">
        <h3 v-if="type === 'create'">Request New Product</h3>
        <h3 v-else-if="type === 'edit'">Edit Request</h3>
        <form @submit.prevent>
            <div class="large-form">
              <p>To request new personalised product, start by selecting any product from our <a href="/wp-content/plugins/worksends/files/worksends-catalogue-price-list.pdf" download>corporate range</a>. Then fill in your personalisation needs on this form.</p>
              <p><a class="ws-button" href="/wp-content/plugins/worksends/files/worksends-catalogue-price-list.pdf" download>Download our Corporate Catalogue & Price List</a></p>
              <p><i>Your Account manager will get in touch with you about confirming the personalisations, stock amount, stocking time and pricing.</i><p>
                <div class="form-line">
                    <div class="form-field">
                        <label>Your Product Name *</label>
                        <input v-model="item.name" required>
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field">
                        <label>Product Type *</label>
                        <select v-model="item.product_type" required>
                            <option value="null">- Choose -</option>
                            <option value="product">Single Product</option>
                            <option value="giftbox">Gift Box</option>
                        </select>
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field">
                        <label>Starting Stock *</label>
                        <input v-model="item.stock" type="number" required>
                    </div>
                </div>
                <div class="form-line" v-if="item.product_type === 'product'">
                    <div class="form-field">
                        <label>Base Product</label>
                        <input v-model="item.base_product">
                        <div class="form-field-desc">Name or link of your chosen base product from <a href="/wp-content/plugins/worksends/files/worksends-catalogue-price-list.pdf" download>Bookblock HUB range</a>.</div>
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field">
                        <label>Product Description *</label>
                        <textarea v-model="item.description" required />
                        <div class="form-field-desc">Your product description to display on campaign pages</div>
                    </div>
                </div>
                <div class="form-line" v-if="item.product_type === 'product'">
                    <div class="form-field">
                        <label>Product Personalisation</label>
                        <textarea v-model="item.customisation" />
                        <div class="form-field-desc">How would you like your product personalised?</div>
                    </div>
                </div>
                <div class="form-line" v-if="item.product_type === 'giftbox'">
                    <div class="form-field">
                        <label>Gift Box Content</label>
                        <textarea v-model="item.box_content" />
                        <div class="form-field-desc">What would you like in your gift box?</div>
                    </div>
                </div>
                <div class="modal-errors">
                    <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
                </div>
            </div>
            <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="type === 'create' ? modals.productRequestsCreate = false : modals.productRequestsEdit = false">CANCEL</span>
              <span class="ws-button" type="submit" @click="submit">{{ type === 'create' ? 'SEND PRODUCT REQUEST' : 'UPDATE PRODUCT REQUEST'}}</span>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "ProductRequestsModal",
    components: {Modal},
    props: {
        requestId: Number,
        fetchItem: {type: Boolean, default: false},
        type: {type: String, default: 'create'},
    },
    data() {
        return {
            item: {name:'',product_type:'',description:'',box_content:'',customisation:'',base_product:'',stock:100},
            errors: {}
        }
    },
    methods: {
        async submitCreate() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Name', value: this.item.name, rules: ['required', 'minLength:1'] },
                { name: 'Product Type', value: this.item.product_type, rules: ['required'] },
                { name: 'Description', value: this.item.description, rules: ['required', 'minLength:1'] },
                { name: 'Stock', value: this.item.stock, rules: ['required', 'posInt'] }
            ]);
            if (Object.keys(this.errors).length) return;
            
            this.item.send_email = true;
            let response = await this.dispatchWaitAndNotify('createProductRequest', this.item);
            this.$emit('created', response.id);
        },
        async submitEdit() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Name', value: this.item.name, rules: ['required', 'minLength:1'] },
                { name: 'Product Type', value: this.item.product_type, rules: ['required'] },
                { name: 'Description', value: this.item.description, rules: ['required', 'minLength:1'] },
                { name: 'Stock', value: this.item.stock, rules: ['required', 'posInt'] }
            ]);
            if (Object.keys(this.errors).length) return;

            let response = await this.dispatchWaitAndNotify('updateProductRequest', {requestId: this.requestId, payload: this.item});
            this.$emit('updated', response.id);
        },
        submit() {
            if (this.type === 'create') {
                this.submitCreate();
            } else if (this.type === 'edit') {
                this.submitEdit();
            }
        },
        close() {
            if (this.type === 'create') {
                this.modals.productRequestsCreate = false
            } else if (this.type === 'edit') {
                this.modals.productRequestsEdit = false
            }
        }
    },
    async mounted() {
        if (this.fetchItem) {
            await this.dispatchWaitAndNotify('fetchProductRequest', {requestId: this.requestId}, false, true);
        }
        if (this.type === 'edit') {
            this.item.name = this.request.name;
            this.item.product_type = this.request.product_type;
            this.item.description = this.request.description;
            this.item.box_content = this.request.box_content;
            this.item.customisation = this.request.customisation;
            this.item.base_product = this.request.base_product;
            this.item.stock = this.request.stock;
        }
    },
    computed: {
        request() {
            return this.$store.state.product.request.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>